import React from 'react';
import type ServicedeskKnowledgeHubBrowseAllCategoriesType from '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-browse-all-categories/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubBrowseAllCategories = lazyForPaint<
	typeof ServicedeskKnowledgeHubBrowseAllCategoriesType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-knowledge-hub-browse-all-categories", jiraSpaEntry: "async-servicedesk-knowledge-hub-browse-all-categories" */ '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-browse-all-categories'
		),
	),
);

const AsyncServicedeskKnowledgeHubBrowseAllCategories = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubBrowseAllCategories}
		pageId="spa-apps/servicedesk/knowledge-hub/browse-all-categories"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskKnowledgeHubBrowseAllCategories;
